<h5 class="mb-2 font-medium">
  {{ 'my-home.my-market-overview.headline' | transloco }}
</h5>
<div class="nav-tabs">
  @for (tab of tabs; track tab.identfier) {
    <div class="nav-item" (click)="activeTab = tab">
      <a class="nav-link cursor-pointer text-transform-none" [class.active]="activeTab.identfier === tab.identfier">
        {{ tab.identfier | transloco }}
      </a>
    </div>
  }
</div>

@if (homeFacade.indications$ | async; as indications) {
  @for (indication of indications | indicationTab: activeTab; track indication.isin) {
    <home-my-market-overview-item [indication]="indication" />
  }
}
